export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Slovenščina'
  },
  'title': 'ODPOKLIC IZDELKOV: SISTEMI VPONK SIMOND ALPINISM IN VERTIKA',
  'homepage': {
    'notice': 'Odpoklic izdelka. Pomembne informacije glede vaše varnosti in opreme.',
    'purchaseWindow': 'Kupili ste sistem vponk Alpinism ali Vertical znamke SIMOND v obdobju od 1. 1. 2022 do 23. 7. 2026.',
    'skus': 'Sistem vponk SPIDER QUICKDRAW (11 cm) (4051175 / 8589547)\r\nSistem vponk ROCKY (17 cm) (4051176 / 8589548)\r\nSistem vponk ROCKY (11 cm) x5 (4171656 / 8608405)\r\nSistem vponk VERTIKA (11 cm) (5499689 / 8935765)\r\nSistem vponk VERTIKA (17 cm) (5500194 / 8935909)',
    'responsibility': 'Proizvodnja osebne varovalne opreme zahteva popolno odgovornost do uporabnikov naših izdelkov. Zato vas obveščamo o odpoklicu sistemov vponk, opremljenih z vponko Rocky Fil.',
    'defect': 'Odkrili smo napako pri kovičenju žičnih vratc na nekaterih vponkah. Ta napaka pri sestavljanju lahko povzroči odpetje ali zlom žičnih vratc in s tem predstavlja tveganje za zlom same vponke v primeru padca.',
    'stopUsing': 'Prosimo vas, da opreme ne uporabljate več in sledite spodnjemu postopku.'
  },
  'procedure': {
    'stopUsing': 'Prosimo vas., da nemudoma prenehate uporabljati to opremo in preverite, ali ima tudi vaš izdelek to napako, pri čemer upoštevajte spodnja navodila:',
    'title': 'Preverite svoje izdelke:',
    'intro': '- Preverite, ali sta obe strani žičnih vratc še vedno trdno pritrjeni na vponko:',
    'step1': 'Vponko primite na eni strani in postavite palec med obe žici (čim bližje kovici). Močno pritisnite navzdol proti telesu vponke.',
    'step2': 'Obrnite vponko in postopek ponovite še na drugi strani žičnih vratc.'
  },
  'outcome': {
    'nok': {
      'body': 'Če se je ob pregledu žica zrahljala: Izdelek takoj prenehajte uporabljati in ga vrnite v najbližjo trgovino DECATHLON. Naša ekipa bo prevzela izdelek z napako in vam takoj vrnila celotno kupnino.',
      'support': 'Če vam obisk trgovine predstavlja težavo ali imate dodatna vprašanja, vam je na voljo naš center za pomoč strankam. Z veseljem vam bomo pomagali poiskati ustrezno rešitev in vas vodili skozi postopek. Dosegljivi smo na telefonski številki: 080 4551 - od ponedeljka do petka, od 9. do 18. ure in v soboto, od 9. do 17. ure.'
    },
    'ok': {
      'body': 'Če ob pregledu žica ostane trdno v ohišju: Vaš izdelek nima te napake, zato ga lahko še naprej uporabljate brez skrbi.'
    }
  },
  'buttons': {
    'ok': 'Moj izdelek je v redu',
    'nok': 'Moj izdelek ima napako!'
  }
} as const
